<template>
  <div class="x-upload-class">
    <el-form ref="formtwo" :model="formtwo" :rules="ruleForm" label-width="120px">
      <el-form-item label="课程名称:" class="x-css-label" prop="name">
        <el-input v-model="formtwo.name" class="x-input-box" clearable></el-input>
      </el-form-item>
      <el-form-item label="课程视频:" class="x-css-label" prop="name">
        <el-input v-model="formtwo.videodata" class="x-input-box" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="课程视频：" prop="video" class="x-css-label x-form-video" style="display:flex;margin-left:0;">
        <video controls :src="videodata" class="avatar video-avatar" style="margin:0;" v-if="videodata!=''"></video>
        <el-upload class="avatar-uploader el-upload--text zxc"
        action="http://peixun.dlbbdk.com/upload/oss"
        :show-file-list="false"
        accept="video/mp4,video/rmvb,video/ogg"
        list-type="picture-card"
        :file-list="fileListVideo"
        :limit="1"
        :on-success="handleVideoSuccess"
        :on-error="videouploaderror"
        :on-exceed="nomore"
        :on-progress="uploadtime"
        :class="{disabled:videohide}">

            <i class="el-icon-plus avatar-uploader-icon">上传视频</i>
        </el-upload>
        <div class="x-video-inputbox">
          <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:10px;"></el-progress>
        </div>
      </el-form-item> -->

      <el-form-item label="上传封面:" class="x-css-label" prop='image'>
        <el-upload
        class="avatar-uploader"
        ref="upload"
        :on-success="myUpload"
        action="http://peixun.dlbbdk.com/upload/oss"
        :on-remove="nouploadimg"
        :limit="1" :file-list="fileListImage"
        accept="image/jpeg,image/png,image/jpg"
        :class="{disabled:imguploadhide}"
        list-type="picture-card">
          <img src="imageUrl" class="avatar" v-if="imageUrl">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>

          <div slot="tip" class="el-upload__tip">建议文件尺寸150*150</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="课程分类：" prop="type">
        <el-radio-group v-model="formtwo.type">
          <el-radio :label="item.id" name="type" v-for="(item,index) in isclasslist">{{item.title}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学习时长:" class="x-css-label x-studytime-css" prop="studytime">
        <el-input v-model="formtwo.studytime" class="x-input-box" clearable></el-input><span class="x-studyspan-css">秒</span>
      </el-form-item>
      <el-form-item label="弹窗间隔:" class="x-css-label x-studytime-css" prop="studytime">
        <el-input v-model="formtwo.studytimetoast" class="x-input-box" clearable></el-input><span class="x-studyspan-css">秒</span>
      </el-form-item>
      <el-form-item label="考试文件：" prop="exam" class="x-exam-papers">
        <el-upload
            class="upload-demo"
            action="http://peixun.dlbbdk.com/upload/oss"
            multiple
            :limit="1"
            :on-success="examfilefun"
            accept=""
            :on-exceed="nomore"
            :file-list="fileListTest">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">格式要求：.csv</div>
        </el-upload>
        <a href="http://yl-hb2.oss-cn-beijing.aliyuncs.com/1.csv" class="x-up-upload">模板下载</a>
        <!-- <el-button size="small" type="primary" @click></el-button> -->
      </el-form-item>
      <el-form-item label="考试通过分数：">
        <el-input-number v-model="num" @change="exampass" :min="0" :max="100" label="描述文字" size="medium"></el-input-number>
      </el-form-item>
      <el-form-item label="关联讲师：">
        <el-select v-model="formtwo.teacher" placeholder="请选择" @change="getteacher">
          <el-option
            v-for="item in teacherlist"
            :key="item.username"
            :label="item.username"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否开启wifi下播放">
        <el-switch
          v-model="iswifi"
          active-color="#BDA97A"
          inactive-color="#999999" @change="getiswifi">
        </el-switch>
      </el-form-item>

      <el-form-item label="请选择WIFI">
        <el-select v-model="formtwo.wifi" multiple placeholder="请选择" @change="getwifi">
          <el-option
            v-for="item in wifidata"
            :key="item.title"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="课程介绍：" prop="introduce">
        <el-input type="textarea" v-model="formtwo.desc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('formtwo')" v-if="okup">确认上传</el-button>
        <el-button type="primary" @click="changeok" v-if="okchange">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
var i=0;
import axios from 'axios';
export default {
  name: 'uploadclass',
  data () {
    return {
      formtwo:{
        name:'',
        type:[],
        region:'',
        regiontwo:[],
        resource:'',
        date1:'',
        desc:'',
        examfile:'',
        studytime:'',
        studytimetoast:'',
        teacher:'',
        videodata:'',
        wifi:[]
      },
      ruleForm:{
        // name:[
        //   {required:true,message:'请输入课件名称',trigger:'blur'}
        // ],
        // image:[
        //   {required:false,message:'请上传封面图片',trigger:'change'}
        // ],
        // type:[
        //   {type:'array',required:true,message:'请至少选择一个课程分类',trigger:'change'}
        // ],
        // region:[
        //   {required:true,message:'请选择学习权限',trigger:'change'}
        // ]
      },
      // formtworef:{
      //   name:'',
      //   video:'',
      //   image:'',
      //   type:[],
      //   region:[],
      //   exam:'',
      //   introduce:false
      // },
      begintime:'',
      overtime:'',
      fileListVideo:[],
      fileListImage:[],
      fileListTest:[],
      imageUrl:'',
      showclasslist:'',//职位列表
      // showdepartlist:'',//列表
      departid:'',//部门id
      isclasslist:'',//课程分类列表
      isclasslistid:[],//课程分类列表的全部id
      getisclasslistid:[],//编辑页带过来的课程数组
      getisregiontwo:[],//编辑页带过来的职位数组
      imgossurl:'',//阿里云图片地址
      videoForm:{
        video:''
      },
      videoFlag:false,
      videoUploadPercent:'',
      formvideo:{
        name:''
      },
      videoArray:'',
      noname:'',
      list:'',
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2019, 10, 10, 9, 40)],
      starttimedata:'开始日期',
      endtimedata:'结束日期',
      testname:'',
      isedit:false,
      iseditid:'0',
      uploadhide:true,
      videohide:false,
      imguploadhide:false,
      inputentry:'输入集数名称',
      isclose:false,
      videouploadsucc:false,//集数名称开关
      removeindex:10,
      removevideolist:10,
      i:'',
      fileListadd:[],
      changevideoindex:'',
      isshowuploadlist:true,
      num:'',
      teacherlist:'',
      teacherid:'',
      videodata:'',
      okup:true,
      okchange:false,
      wifidata:'',
      iswifi:false,
      onlywifi:0,
      wifiarr:[]
    }
  },
  watch:{

  },
  created() {
    this.classlist();
    this.teacherda();
    console.log(this.$route.params.classdata);
    console.log(this.$route.params.isedit);
    // 判断从编辑页
    if(this.$route.params.isedit == 1){
      this.fromeditpage(this.$route.params.classdata)
    }
    this.misslistfun()//wifi列表
  },
  methods: {
    //是否开启
    getiswifi:function(val){
      let that = this;
      console.log(val);
      if(!val){
        that.onlywifi=0;
      }else if(val){
        that.onlywifi=1;
      }
    },
    getwifi:function(val){
      let that = this;
      console.log(val);
      that.wifiarr = val;
    },
    // WIFI列表
    misslistfun(){
      axios.get('/admin/wifi/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data);
            this.wifidata = response.data.data;//部门列表数据
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //删除封面后 显示上传按钮
    nouploadimg:function(){
      this.imguploadhide = false;
    },
    //关联讲师
    getteacher:function(val){
      console.log(val);
      this.teacherid = val;
    },
    //讲师列表
    teacherda:function(){
      axios.get('/admin/lecturer/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.teacherlist = response.data.data;
        }else{
          this.allmainproloading = false
          console.log('失败');
          this.$router.push({name:'Login'});
          localStorage.token = '';
          console.log(localStorage.token);
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //
    exampass(){

    },
    // 表单验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getImageTypeIndex(index){
      console.log(index);
    },
    // 从编辑打开
    fromeditpage(allreadeydata){
      console.log('从编辑打开：'+JSON.stringify(allreadeydata));
      this.okup = false;
      this.okchange = true;
      this.iseditid = allreadeydata.id;

      this.formtwo.name = allreadeydata.title;//课程名称
      this.formtwo.desc = allreadeydata.content;//课程介绍

      console.log('带过来的课程分类id：'+this.cateid);

      this.formtwo.type = allreadeydata.cateid;//课程分类

      this.videoArray = allreadeydata.video_url;//视频
      this.videodata = allreadeydata.video_url;//视频显示
      this.formtwo.videodata = allreadeydata.video_url;

      this.formtwo.teacher = allreadeydata.lecturerid;

      this.fileListImage.push({
        'url':allreadeydata.cover
      })//封面
      this.imgossurl = allreadeydata.cover;//封面

      this.formtwo.studytime = allreadeydata.duration;//学习时长
      this.formtwo.studytimetoast = allreadeydata.hit_time;
      this.num = allreadeydata.exampass//考试通过率
      // 判断考试文件为空 则清空考试文件列表
      if(allreadeydata.doc_url==""){
        console.log('为空');
        this.fileListTest = [];
      }else{
        this.fileListTest.push({
          'name':allreadeydata.doc_name,
          'url':allreadeydata.doc_url
        })//考试文件显示

        this.formtwo.examfile = allreadeydata.doc//考试文件赋值
        this.testname = allreadeydata.doc_name;//考试文件名字
      }

      //
      if(allreadeydata.only_wifi==1){
        this.iswifi=true;
        this.onlywifi=1;
      }else{
        this.iswifi=false;
        this.onlywifi=0;
      };
      //
      this.formtwo.wifi=allreadeydata.wifi;
      this.wifi = allreadeydata.wifi;
      console.log(this.formtwo.wifi);
    },
    // 课件删除之前
    beforeremove(file, fileList){
      console.log(file);
      console.log(fileList);

      // return false;
    },
    // onremove(err, file, fileList){
    //   console.log('onremove');
    // },
    // 考试文件成功
    examfilefun(res, content){
      console.log(res);
      console.log(content);
      this.testname = content.name;
      console.log(res.data[0].url);
      if(res.status == 1){
        this.formtwo.examfile = res.data[0].url
      }else{
        this.$message({
          showClose: true,
          message:res.data.msg ,
          type: 'error'
        });
      }
    },
    // 上传超过限制
    nomore(){
      this.$message({
        showClose: true,
        message:'只能上传一个哦，试试先删除再添加吧' ,
        type: 'error'
      });
    },
    // 视频上传验证
    beforeUploadVideo(file) {
      // if(!this.formvideo.name){
      //   this.$message({
      //     showClose: true,
      //     message:'请填写级数名称' ,
      //     type: 'error'
      //   });
      //   return false
      // }else{
      //   const isLt10M = file.size / 1024 / 1024  < 10;
        if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb','video/mp3'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的视频格式');
            return false;
        }
      //   // if (!isLt10M) {
      //   //     this.$message.error('上传视频大小不能超过10MB哦!');
      //   //     return false;
      //   // }
      // }

    },
    // 修改课件视频
    changevideo(index){
      this.changevideoindex = index;
      this.fileListadd = [];
      this.isshowuploadlist = true;//每次修改视频  恢复默认显示上传列表
    },
    removevideo(index){
      console.log(index);
      console.log(this.removevideolist);
      // this.removevideolist = index;
      console.log(this.videoArray);
      this.videoArray.splice(index,1);
      console.log(this.videoArray);
    },
    changeuploadvideo(){
      // console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
    },
    // 视频上传进度条
    // uploadVideoProcess(event, file, fileList){
    //   console.log(file);
    //     this.videoFlag = true;
    //     this.videoUploadPercent = file.percentage.toFixed(0);
    // },
    // 视频上传成功回调
    handleVideoSuccess(res, file) {

      console.log(res);                            //获取上传图片地址
      console.log(file);
        this.videoFlag = false;//进度条
        this.videoUploadPercent = 100;
        if(res.status == 1){//阿里云成功
            console.log(res.data[0].url);
            this.videoArray=res.data[0].url;
            this.videouploadsucc = true;//集数开关
            this.videodata = res.data[0].url;
            console.log(this.videoArray);
            // 显示上传框
            // this.uploadhide = true
            // this.videohide = false
        }else{
            // this.$message.error('视频上传失败，请重新上传！');
            this.$message({
              showClose: true,
              message:res.msg ,
              type: 'error'
            });
        }
    },
    // 修改视频成功回调
    changevideosucc(res,file){
      console.log(res);                            //获取上传图片地址
      console.log(file);
      console.log(this.changevideoindex);
      this.videoArray[this.changevideoindex].url=res.data[0].url;
      this.isshowuploadlist = false;
    },
    // 修改视频 状态改变回调
    changevideochange(){

    },
    // 视频上传失败回调
    videouploaderror(){
      console.log('视频上传失败回调');
      this.$message({
        showClose: true,
        message:'上传视频失败，请检查网络，稍后重试',
        type: 'error'
      });
    },
    // 文件上传时的回调
    uploadtime(event, file, fileList){
      console.log('文件上传时的钩子');
      this.videoFlag = true
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
      console.log(this.videoUploadPercent);
      // 隐藏上传框
      // this.uploadhide = false
      // this.videohide = true
    },
    // 视频删除按钮
    entericon(index){
      this.removeindex = index;
      this.isclose = true;
    },
    leaveicon(index){
      // console.log(this.removeindex);
      // console.log(index);
      this.removeindex = index+100;
      this.isclose = false;
    },
    beforeAvatarUpload(file){
      // console.log(file);
      // const isJPG = file.type === 'image/png';
      // const isLt2m = file.size / 1024 / 1024 < 2;
      // if(!isJPG){
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      // if(!isLt2m){
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isJPG && isLt2m;
    },
    // 上传封面成功
    myUpload:function(response,file,fileList){
      console.log(response);
      if(response.status == 1){
        console.log(response.data[0].url);
        this.imgossurl = response.data[0].url;
        this.imguploadhide = true;//隐藏
      }else{
        this.$message({
          showClose: true,
          message:res.status.msg ,
          type: 'error'
        });
      }
    },
    // 删除封面
    removeimgupload(file, fileList){
      this.imguploadhide = false;//显示
    },
    //确认修改
    changeok:function(){

      console.log(this.videoArray);
      axios.get('/admin/course/edit', {
        params: {
          id:this.iseditid,
          sec: localStorage.token,
          title:this.formtwo.name,
          video:this.formtwo.videodata,
          cover:this.imgossurl,
          cateId:this.formtwo.type,
          duration:this.formtwo.studytime,
          docUrl:this.formtwo.examfile,
          content:this.formtwo.desc,
          docName:this.testname,
          score:this.num,
          lecturerId:this.teacherid,
          hitTime:this.formtwo.studytimetoast,
          onlyWifi:this.onlywifi,
          wifi:this.wifiarr
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
              this.$message({
                showClose: true,
                message: '修改课程成功',
                type: 'success'
              });

            this.$router.push({name:'mainpro'});
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 确认上传
    onSubmit(){
      console.log(this.videoArray);
      console.log('从编辑打开的id：'+this.iseditid);
      console.log('课程名称：'+this.formtwo.name);
      console.log('课件：'+JSON.stringify(this.videoArray));
      console.log('头像地址：'+this.imgossurl);
      console.log('课程分类：'+this.formtwo.type);
      console.log('学习时长：'+this.formtwo.studytime);

      // console.log('部门：'+this.formtwo.region);
      // console.log('职位'+this.formtwo.regiontwo);
      console.log('考试文件：'+this.formtwo.examfile);
      console.log('考试文件名字：'+this.testname);
      console.log('考试通过率：'+this.num);
      console.log('关联讲师：'+this.teacherid);
      console.log('课程介绍：'+this.formtwo.desc);
      console.log('是否开启WiFi：'+this.onlywifi);
      console.log('开启的wifi：'+this.wifi);
      // console.log('考试时长：'+this.formtwo.studytime*60);
      console.log();
      // console.log('学习任务：'+this.formtwo.resource);
      let starttime = this.formtwo.date1[0]
      let endtime = this.formtwo.date1[1]
      //时间转时间戳
       var date = new Date(starttime);
       this.begintime = Date.parse(date) / 1000;
       // console.log('任务期限开始时间戳：'+this.begintime);

        var date2 = new Date(endtime);
        this.overtime = Date.parse(date2) / 1000;
        // console.log('任务期限结束时间戳：'+this.overtime);
        console.log('课程介绍：'+this.formtwo.desc);
        console.log('考试通过率：'+this.num);
        axios.get('/admin/course/add', {
          params: {
            // id:this.iseditid,
            sec: localStorage.token,
            title:this.formtwo.name,
            video:this.formtwo.videodata,
            cover:this.imgossurl,
            cateId:this.formtwo.type,
            // permission:this.formtwo.regiontwo,
            duration:this.formtwo.studytime,
            docUrl:this.formtwo.examfile,
            content:this.formtwo.desc,
            docName:this.testname,
            score:this.num,
            lecturerId:this.teacherid,
            hitTime:this.formtwo.studytimetoast,
            onlyWifi:this.onlywifi,
            wifi:this.wifiarr
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
                this.$message({
                  showClose: true,
                  message: '添加课程成功',
                  type: 'success'
                });

              this.$router.push({name:'mainpro'});
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
    },
    // 职位列表
    positionlist(){
      axios.get('/learn/organization/jobList', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.showclasslist = response.data.data.list;//部门列表数据
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 职位列表
    departlist(){
      axios.get('/learn/organization/list', {
        params: {
          sec: localStorage.token,
          parentId:this.departid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            // console.log(response.data.data.list);
            this.showdepartlist = response.data.data.list//职位列表数据
            console.log(this.showdepartlist);
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 下拉框选择部门
    changeselect(departid){
      this.departid = departid;
      console.log('选中的部门id：'+this.departid);
      this.departlist()
      // this.formtwo.regiontwo = ''//重置职位列表
    },
    // 课程分类列表
    classlist(){
      axios.get('/admin/cate/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data);
            this.isclasslist = response.data.data;
            this.allmainproloading = false

        }else{
          console.log('失败');
          this.$router.push({name:'Login'});
          localStorage.token = '';
          console.log(localStorage.token);
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
.el-input--small .el-input__inner{
  margin: 0;
}
</style>
<style media="screen">
.x-css-label{
  text-align: left;
}.x-css-label .x-input-box{
  /* width: auto; */
}.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #BDA17A;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
    margin: auto;
  }.x-upload-class{
    text-align: left;
  }.avatar-uploader-icon{
    width: 148px;
    height: 148px;
    line-height: 148px;
  }.x-form-video .x-input-box{
    width: 148px;
    margin-bottom: 0;
    margin-right: 0;
    margin-top: 15px;
  }.avatar-uploader .el-upload,.x-video-inputbox{
    /* float: left; */
    /* margin-right: 15px; */
    /* margin-left: 15px; */
    display: inline-block;
    margin-right:20px;
    position: relative;
  }.x-video-inputbox.x-video-inputbox2{
        background-color: #f5f5f580;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    margin-right: 15px;
    margin-left: 31px;
  }.avatar-uploader .el-upload{
    /* margin-left: 15px; */
  }.x-css-label.x-form-video .el-form-item__content{
    /* height: 315px;
    overflow-x: scroll;
    padding: 25px 15px;
    border: 1px solid #f5f5f5;
    overflow-y: hidden;
    width: 85%; */
    flex-direction: row;
    flex-wrap: nowrap;
    white-space:nowrap;
    box-sizing: border-box;
    margin-left: 0!important;
    display: flex;
  }
</style>
<style>
.disabled .el-upload--picture-card{
  display: none
}.el-upload.el-upload--picture-card{
  margin-right: 15px;
}.x-in-hide{
  margin-right: 15px;
}.x-gray-btn{
  background-color: #A6A6A6;
  color: #fff;
  cursor:context-menu ;
}.x-css-label.x-form-video .avatar-uploader.el-upload--text.zxc{
  display: table;
}.el-upload--picture-card i{
  font-size: 14px;
}.x-form-video .x-input-box .el-input__inner{
  text-align: center;
}.x-upload-succ{
  font-size: 10px;
  color: #28B65C;
  text-align: center;
}.x-close-box{
  position: absolute;
  right: -8px;
  top: -8px;
  cursor: pointer;
}.x-edit-icon{
  position: absolute;
  left: 50%;
  top: 30%;
  color: #fff;
  background-color: rgba(255,255,255,0.4);
  padding: 5px;
  border-radius: 50%;
  margin-left: -10px;
  cursor: pointer;
  font-size: 20px;
}.x-exam-papers .el-upload-list__item.is-success{
  width: auto;
  display: inline-block;
}.x-studytime-css{
  width: 200px;
}.x-studyspan-css{
  position: absolute;
  right: -40px;
  top: 2px;
  color: #ccc;
}.x-up-upload{
  text-decoration: none;
  color: #fff;
  background-color: #779690;
  width: 80px;
  text-align: center;
  border-radius: 4px;
  margin-left: 14px;
  height: 33px;
}.x-exam-papers .el-form-item__content{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadclass.vue